import { OrderMethod } from '../../../../../services/exports/Constants';

export default {
  [OrderMethod.Pickup]: 'Pickup',
  [OrderMethod.Delivery]: 'Delivery',
  [OrderMethod.OnSite]: 'On site',
};
